/**
 * @file        src/components/DrawerSkeleton.jsx
 * @description Loading body for a details drawer (.lk-modal.lk-tall). Shaped like
 *              the drawer it stands in for — a summary grid over a few section
 *              blocks — so the reserved space reads as the document loading
 *              rather than as an empty modal that then fills.
 *
 *              It exists for STABILITY, not decoration. The drawers used to render
 *              a single "Loading…" line, so the modal opened at that line's height
 *              and jumped when the data landed (measured on the flight drawer:
 *              244px → 1,410px). `.lk-tall` fixes the frame and this fills it.
 * @author      Kinetika Labs
 * @created     2026-09-25
 * @changelog
 *   - 2026-09-25 Claude — Initial.
 */
export default function DrawerSkeleton({ cells = 6, blocks = 2 }) {
  return (
    <div className="drawer-skel" aria-busy="true" aria-label="Loading details">
      <div className="drawer-skel-grid">
        {Array.from({ length: cells }).map((_, i) => <div key={i} className="skeleton sk-line" />)}
      </div>
      {Array.from({ length: blocks }).map((_, i) => <div key={i} className="skeleton sk-block" />)}
    </div>
  );
}
